const DEMOGRAPHIC_GROUP_FILTER_VALUES = {
    GENDER: 'GENDER',
    AGE: 'AGE',
};

export default DEMOGRAPHIC_GROUP_FILTER_VALUES;
